import './CompletedCollectionOverlayContent.styl';
import { observer } from 'mobx-react-lite';
import { useTranslationsContext } from 'store/translations';
import { Button } from 'components/core';
import { ICollectionState } from 'src/types';
import { useNavigate } from 'react-router';
import { routes } from 'utils/router';
import { useStoreContext } from 'store/app';
import Ticket from 'assets/img/ticket.png';
import classNames from 'classnames';
import { useEffect } from 'react';
import OKSDK, { ApiResultStatus } from '@odnoklassniki/ok-apps-sdk';
import { OverlayConfettiAnimation } from 'components/layout/overlayConfettiAnimation';

interface Props {
    collection: ICollectionState;
}

export const CompletedCollectionOverlayContent = observer(({ collection }: Props) => {
    const { translate } = useTranslationsContext();
    const { catalogConfig, isMob, logOperation } = useStoreContext();
    const navigate = useNavigate();
    const collectionConfig = catalogConfig?.collections.find((x) => x.id === collection.id);

    useEffect(() => {
        logOperation('collection_complete', 'render', collection.id);
    }, []);

    const onCompletedClick = () => {
        logOperation('collection_complete', 'reward_view', collection.id);
        navigate(routes.wheel, { state: { collectionId: collection.id } });
    };

    const onShareClick = () => {
        logOperation('collection_complete', 'share_start', collection.id);
        OKSDK.Methods.Layers.postMediatopic({
            media: [
                {
                    description: 'Соберите свою коллекцию игрушек и поучаствуйте в розыгрыше призов!',
                    imageUrl: collectionConfig?.custom_params?.fullImage,
                    title: 'Новогодние коллекции от ОК',
                    type: 'link',
                    url: 'https://ok.ru/game/collections'
                }
            ]
        }).then(({ status }) => {
            if (status === ApiResultStatus.OK) {
                logOperation('collection_complete', 'share_success', collection.id);
            } else {
                logOperation('collection_complete', 'share_cancel', collection.id);
            }
        });
    };

    return (
        <div className="collection-overlay">
            <OverlayConfettiAnimation />
            <img className="collection-overlay-image" src={collectionConfig?.custom_params?.fullImage}></img>
            <div className="collection-overlay-title">{translate('collection.completed.title')}</div>
            <div className="collection-overlay-desc">
                <span>{translate('collection.completed.desc-start')}</span>
                <img className="collection-overlay-desc-ticket" src={Ticket}></img>
                <span>{translate('collection.completed.desc-end')}</span>
            </div>
            <div className={classNames('collection-overlay-buttons', { row: !isMob })}>
                <Button className="collection-overlay-button" onClick={onCompletedClick}>
                    {translate('collection.completed.continue')}
                </Button>
                {isMob && (
                    <Button
                        className={classNames('collection-overlay-button', { orange: !isMob, invisible: isMob })}
                        onClick={onShareClick}
                    >
                        {translate('collection.completed.share')}
                    </Button>
                )}
            </div>
        </div>
    );
});
